import { CheckCircle2, HandCoins, Timer, Zap } from 'lucide-react';

const pillars = [
  {
    icon: Timer,
    title: 'Quote in 15 seconds',
    detail: 'No forms maze. Enter amount, tap generate, share instantly.',
  },
  {
    icon: HandCoins,
    title: 'Only pay when you get paid',
    detail: 'Usage-based pricing keeps risk low and aligns with outcomes.',
  },
  {
    icon: Zap,
    title: 'Read their mind',
    detail: 'Know the second they open your quote so follow-up lands on time.',
  },
  {
    icon: CheckCircle2,
    title: 'Trusted checkout',
    detail: 'Buyers complete payment in a familiar Stripe-powered flow.',
  },
];

export default function ProofSection() {
  return (
    <section className="bg-[#f8f5ef] px-6 py-20">
      <div className="container mx-auto max-w-6xl">
        <div className="max-w-3xl">
          <p className="text-xs font-semibold uppercase tracking-[0.14em] text-slate-500">Why teams switch</p>
          <h2 className="mt-3 text-3xl font-bold text-slate-900 md:text-4xl">Close faster without adding process</h2>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2">
          {pillars.map((pillar) => (
            <article key={pillar.title} className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
              <div className="inline-flex rounded-xl bg-slate-950 p-2 text-white">
                <pillar.icon className="h-4 w-4" />
              </div>
              <h3 className="mt-3 text-xl font-semibold text-slate-900">{pillar.title}</h3>
              <p className="mt-2 text-sm text-slate-600">{pillar.detail}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
